<template>
  <div v-if="marker">
   <div class="alignRight">
      <button @click="jump(marker)" class="btn--icon btn--subtile" style="transform: translateY(-9px); margin-right: 5px;">
        <svgicon icon="focus"  width="32" height="32" color="#000000"></svgicon>
      </button>
      <button @click="fullscreen()" class="btn--subtile" style="transform: translateY(-9px); margin-right: 5px;">
        <svgicon icon="fullscreen" v-if="!$parent.fullscreen" width="32" height="32" color="#000000"></svgicon>
        <svgicon icon="fullscreenclose" v-if="$parent.fullscreen" width="32" height="32" color="#000000"></svgicon>
      </button>
      <button v-if="onReminderList()" @click="removeReminder()" class="btn--icon btn--subtile btn--reminder-active" style="transform: translateY(-9px); margin-right: 5px;">
        <svgicon icon="star" width="32" height="32" color="#F2C247"></svgicon>
      </button>
      <button v-if="!onReminderList()" @click="setReminder()" class="btn--icon btn--subtile btn--reminder" style="transform: translateY(-9px); margin-right: 5px; margin-left: -5px;">
        <svgicon icon="star-empty"  width="32" height="32" color="#000000"></svgicon>
      </button>
      <button @click="closeEditMarker()" title="Abbrechen" style="transform: translateY(-9px);" class="btn--icon"><svgicon icon="close" width="32" height="32" color="#000000"></svgicon></button>
   </div>
    <!-- <h1 v-if="!typeLink">Beitrag</h1>
    <h1 v-if="typeLink">Link</h1> -->
    <h1 style="margin-bottom: 0px;" v-bind:class="{ 'color-action':(marker.priority === '3'), 'color-warn':(marker.priority === '2'), 'color-error':(marker.priority === '1') }"><blur-editable :content="marker.title" @change="change()" @update="marker.title = $event"></blur-editable></h1><br />

    <label>Tags</label>
    <taglist :postKey="marker['.key']"></taglist>

    <!-- <label>
      Titel
      <input v-model="marker.title" @change="change()" @keyup.enter="save()">
    </label>
    <br /> -->
    <label v-if="typeLink">
      Link
      <input v-model="marker.link" @change="change()" @keyup.enter="save()">
    </label>
    <br v-if="typeLink" />
    <!-- <button @click="save()">Speichern</button> -->
    <!-- <br /><br /> -->
    <br />
    <label>Inhalt</label>

    <editor-firepad :hash="marker['.key']"></editor-firepad>
    <!-- <div v-for="user in users" v-bind:key="user['.key']"  v-if="user['.key'] == marker.user">
      <label>Autor</label>
      {{user.email}}
    </div> -->

    <!-- <div v-if="marker.modified"><br />
      <label>zuletzt bearbeitet</label>
      {{marker.modified|formatDate}}
    </div> -->

    <br />
    <label>Priorität</label>
    <button @click="selectPriority('1')" name="prio" id="prio1" v-bind:class="{ 'btn--selected':(marker.priority === '1') }" class="btn--padding btn--select  btn--subtile color-error"><svgicon icon="flag"  width="32" height="32" color="#000000"></svgicon><b>1</b></button>
    <button @click="selectPriority('2')" name="prio" id="prio2" v-bind:class="{ 'btn--selected':(marker.priority === '2') }" class="btn--padding btn--select  btn--subtile color-warn"><svgicon icon="flag"  width="32" height="32" color="#000000"></svgicon><b>2</b></button>
    <button @click="selectPriority('3')" name="prio" id="prio3" v-bind:class="{ 'btn--selected':(marker.priority === '3') }" class="btn--padding btn--select  btn--subtile color-action"><svgicon icon="flag"  width="32" height="32" color="#000000"></svgicon><b>3</b></button>
    <br />
    <label v-if="marker.created" style="margin-bottom: 0px;">
      Erstellt
    </label>
    {{marker.created|formatDate}}<br />
    <br />
    <label>
      Icon<br />
    </label>
    <button v-for="icon in icons" v-bind:key="icon['.key']" class="btn--select" @click="selectIcon(icon.name)" v-bind:class="iconClass(icon.name, marker.icon)">
      <svgicon :icon="icon.name" width="32" height="32" color="#000000"></svgicon>
    </button>
    <br />
    <button @click="deleteMarker()" class="btn--subtile"><svgicon icon="delete" width="32" height="32" color="#000000"></svgicon> Beitrag löschen</button>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import BlurEditable from '@/components/BlurEditable' // eslint-disable-line
import Taglist from '@/components/Taglist' // eslint-disable-line
import moment from 'moment'
import EditorFirepad from '@/components/EditorFirepad' // eslint-disable-line

var db = firebase.database()
var iconsRef = db.ref('icons')
var usersRef = db.ref('users')

export default {
  props: ['marker', 'setJump'],
  components: {
    BlurEditable,
    Taglist,
    EditorFirepad
  },
  data () {
    return {
      keyBefore: this.marker['.key'],
      titleBefore: this.marker.title,
      iconBefore: this.marker.icon,
      typeLink: false,
      saved: false,
      currentUser: firebase.auth().currentUser.uid
    }
  },
  updated () {
    if (this.setJump) {
      this.$parent.$refs.map.mapObject.invalidateSize()
      this.jump(this.marker)
    }
    this.keyBefore = this.marker['.key']
    this.titleBefore = this.marker.title
    this.iconBefore = this.marker.icon
    this.saved = false
    if (this.marker.type === 'link') {
      this.typeLink = true
    } else {
      this.typeLink = false
    }
  },
  mounted () {
    this.$emit('update-marker', this.marker)
  },
  methods: {
    iconClass: function (current, active) {
      if (current === active) {
        return 'btn--icon btn--selected'
      } else {
        return 'btn--icon btn--subtile'
      }
    },
    fullscreen: function () {
      this.$emit('fullscreen', true)
    },
    jump (marker) {
      let data = { latLng: marker.position, zoom: 2.5 }
      this.$emit('jump', data)
    },
    selectIcon: function (icon) {
      this.marker.icon = icon
      this.$emit('update-marker', this.marker)
      this.saved = true
    },
    selectPriority: function (priority) {
      this.marker.priority = priority
      this.$nextTick(() => {
        this.$emit('update-marker', this.marker)
        this.saved = true
      })
    },
    save: function () {
      if (this.marker.title != null) {
        this.$emit('update-marker', this.marker)
        this.saved = true
        this.closeEditMarker()
      }
    },
    change: function () {
      this.saved = false
      this.$emit('update-marker', this.marker)
      this.saved = true
    },
    deleteMarker: function () {
      var r = confirm('Sind Sie sicher, dass Sie diesen Beitrag unwiederruflich löschen möchten?')
      if (r === true) {
        this.$emit('delete-marker', this.marker)
        this.closeEditMarker()
      }
    },
    closeEditMarker: function () {
      this.$emit('edit-marker-close')
    },
    reset: function () {
      if (this.saved === false && this.marker['.key'] === this.keyBefore) {
        this.marker.title = this.titleBefore
        this.marker.icon = this.iconBefore
      }
    },
    onReminderList: function () {
      if (this.reminderItems[this.marker['.key']] !== undefined) {
        return true
      }
      return false
    },
    setReminder: function () {
      usersRef.child(this.currentUser).child('reminder').child(this.marker['.key']).child('added').set(moment().format())
    },
    removeReminder: function () {
      usersRef.child(this.currentUser).child('reminder').child(this.marker['.key']).remove()
    }
  },
  beforeUpdate () {
    // this.reset()
  },
  beforeDestroy () {
    this.reset()
  },
  firebase () {
    return {
      icons: iconsRef,
      users: usersRef,
      reminderItems: {
        source: usersRef.child(this.currentUser).child('reminder'),
        asObject: true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EditMarker.vue